<!--
 * @Author: yindengli
 * @Date: 2023-07-20 17:47:46
 * @LastEditTime: 2023-11-01 14:14:40
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\FaqCmp\Faq.vue
-->
<template>
  <div class="faq-page" v-show="loading">
    <div class="main-content">
      <SearchCmp ref="searchCmp" :categories="categories" :initValue="initValue" @search="handleSearch">
      </SearchCmp>
      <HotStatistics v-if="!hideType && loading" class="hot-statistics" @hotRecommend="hotRecommend"></HotStatistics>
      <SortList :list="allQueryList" @toDetail="handleToDetail" @likesAdd="handleLikes" ref="sortList"
        :current="params.pageNum" :pageSize.sync="params.pageSize" :total="total" :byTitle="params.byTitle"
        @change="changePageNum"></SortList>
    </div>
    <div class="right-content">
      <TopQueryList :list="topList" @toDetail="handleToDetail"></TopQueryList>
    </div>
    <a-modal class="detail-modal" v-model="isDetailModalVisible" :footer="false" centered width="85%"
      :bodyStyle="{ height: '90vh', overflowY: 'auto', padding: '40px' }" destroy-on-close @after-close="resetKey">
      <DetailModal :curId="curQueryId" @toDetail="handleToDetail" @likesAdd="handleLikes"></DetailModal>
    </a-modal>
    <a-modal v-model="visible" width="360px" title="提示" @ok="openCloud">
      未能获取到姓名，请前往<a href="https://support.seeyon.com/" style="color:#007AFF;">客户服务云平台</a>登录后访问此FAQ
    </a-modal>
  </div>
</template>

<script>
import SearchCmp from "./home/SearchCmp.vue";
import SortList from "./home/SortList.vue";
import TopQueryList from "./home/TopQueryList.vue";
import DetailModal from "./detail/DetailModal";
import HotStatistics from "./home/HotStatistics.vue";
// import Login from '@/components/login/Login'

import { getIndexInfo, getCategory, getTops } from "../../api/faq";
import axios from 'axios';
// import eventBus from '@/utils/eventBus'
import { getCookie } from "@/utils/common";
export default {
  name: "App",
  components: {
    SearchCmp,
    SortList,
    TopQueryList,
    DetailModal,
    HotStatistics,
    // Login
  },
  data() {
    return {
      params: {
        faqCategoryId: "",
        faqContent: "",
        byTitle: 1,
        pageNum: 1,
        pageSize: 15,
      },
      total: 10,
      categories: [],
      queryList: [],
      allQueryList: [],
      topList: [],
      isDetailModalVisible: false,
      curQueryId: "",
      loginKey: "",
      isLogin: false,
      initValue: {
        name: '全部',
        id: 0,
      },
      // 内容区域高度
      sortListHeight: 0,
      //滚动高度
      sortListScrollTop: 0,
      isShow: false,
      visible: false,
      hideType: window.localStorage.getItem("openSeeyonVersion") == 'V8',
      loading: false,
    };
  },
  created() {
    this.handleOutlink();
  },
  methods: {
    async handleOutlink(){
      // 外部分享链接跳转FAQ
      if (this.$outerFaqLink && this.$route.query.url) {
        var outerLink = this.$outerFaqLink;
        await axios({
          url: outerLink
        }).then(res => {
          if (typeof (res.data.data.msg) != "undefined") {
            this.$error({ title: res.data.data.msg });
            this.$router.push('/faq');
            return;
          }
          if (res.data.data.type == "faq") {
            this.handleToDetail(res.data.data.id);
          } else {
            window.location.href = res.data.data.redirectUrl;
          }
        }, err => {
          console.log(err)
        })
        this.initFaq();
      }else{
        this.initFaq();
      }
    },
    initFaq() {
      this.initCategories();
      this.initTopList();
    },
    hotRecommend(content) {
      this.$refs.searchCmp && this.$refs.searchCmp.onSearch(content);
    },
    //获取分类列表
    initCategories() {
      getCategory().then((res) => {
        this.loading = true;
        try {
          if (res.data) {
            this.categories = res.data || [];
          }
          if(this.$route.params.from == 'home'){
            localStorage.setItem('openseeyonCategory', 0)
            this.initValue = { id: 0, name: '全部' };
            this.params.faqContent = this.$route.params.keyword;
          }else{
            let id = -1;
            // console.log(this.$route.params,1111111)
            // 菜单点进来默认faq
            if(this.$route.params.faqCategoryId || (this.$outerFaqLink && this.$route.query.url)){
              id = this.$route.params.faqCategoryId;
            }else{
              // 切换版本 默认上次类型，没有的话默认faq
              let type = localStorage.getItem('openseeyonCategory');
              type && (id = Number(type));
            }
            if(id === 0){
              this.initValue = { id: 0, name: '全部' };
            }else{
              let targetCategory = this.categories.find(item => {
                return item.id === id;
              });
              if(targetCategory){
                this.initValue = targetCategory;
              }else{
                localStorage.setItem('openseeyonCategory', -1)
                const target = this.categories.find(item => {
                  return item.id === -1;
                });
                if(target){
                  this.initValue = target;
                }
              }
            }
          }
          this.$refs.searchCmp.handleInitData(this.initValue.id)
            this.$nextTick(() => {
              this.params.faqCategoryId = this.initValue.id;
              this.isShow = true;
              //获取FAQ列表
              this.getAllList(this.params);
              this.$nextTick(() => {
                const searchInput = this.$refs.searchCmp.$el.querySelector('.ant-input-search input');
                // console.log(this.$refs.searchCmp.$el.querySelector('.ant-input-search input'));
                if (searchInput) {
                  searchInput.focus();
                }
              })
            })

        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      })
    },
    initTopList() {
      getTops().then((res) => {
        try {
          if (res.data) {
            this.topList = res.data || [];
          }
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      })
    },
    getAllList(params) {
      getIndexInfo(params).then((res) => {
        try {
          if (res.data) {
            var { list, pageNum, total } = res.data;
            this.queryList = list || [];
            this.params.pageNum = pageNum;
            this.total = total;
            this.allQueryList = this.allQueryList.concat(this.queryList);
          }
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      });
    },

    /**
     * 获取搜索组件传回来的搜索条件 需要判断是不是切换类型触发的搜索，是的话需要把allQueryList重置一下
     **/
    handleSearch({ keyword, id, byTitle }, isChange) {
      if (isChange) {
        this.allQueryList = [];
      }
      this.params.faqContent = keyword;
      this.params.faqCategoryId = id;
      this.params.byTitle = byTitle
      this.params.pageNum = 1;
      window.localStorage.setItem('openseeyonCategory', id);
      this.getAllList(this.params);
    },

    handleToDetail(id) {
      if (id) {
        let cookieNickName = getCookie("nickName");
        let cookieLoginKey = getCookie('loginKey');
        if (cookieLoginKey && !cookieNickName) {
          this.visible = true;
          return;
        }
        this.curQueryId = id;
        this.isDetailModalVisible = true;
      } else {
        this.$warning({ title: "Faq不存在！" });
      }
    },
    changePageNum(page, pageSize) {
      this.params.pageNum = page;
      this.params.pageSize = pageSize;
      this.getAllList(this.params);
    },
    changePageSize(current, size) {
      this.params.pageNum = 1;
      this.params.pageSize = size;
      this.getAllList(this.params);
    },
    resetKey() {
      this.curQueryId = "";
    },
    handleLikes(id, likeNum) {
      this.queryList.forEach((item) => {
        if (item.id == id) {
          item.likesNum = likeNum;
        }
      });
    },
    loginSuccess() {
      this.isLogin = true;
    },
    openCloud() {
      window.open('https://support.seeyon.com/');
    }
  },
  watch: {

  },
};
</script>

<style scoped lang="scss">
.faq-page {
  max-width: 1500px;
  width: 90%;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  height: 100%;
  display: flex;
}

.main-content {
  display: inline-block;
  min-width: 470px;
  width: 71.4%;
  height: 100%;
  padding-top: 30px;
  background: #ffffff;
  border-radius: 4px;
  border-radius: 6px;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .search-cmp,
  .hot-statistics {
    padding: 0 30px;
  }
}


.right-content {
  display: inline-block;
  min-width: 180px;
  width: 28.6%;
  padding-left: 20px;
}

.pager-row {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 20px 52px 20px 0;
  background: #fff;
}

.pager-row .ant-pagination {
  text-align: right;
}

#app .ant-row-flex {
  height: 100%;
  flex-wrap: nowrap;
}

.login-page {
  padding: 0 500px;
}

@media screen and (max-width: 1024px) {
  .right-content {
    display: none;
  }

  .main-content {
    min-width: 100%;
  }

  ::v-deep .ant-col-20 {
    width: 94%;
  }

  ::v-deep .ant-modal-body {
    padding: 40px 10px 10px !important;
    overflow-x: hidden;
  }
}

@media screen and (max-width: 824px) {
  .faq-page {
    width: 100%;
    padding: 0;
  }

  .main-content {
    padding: 15px 10px 0;

    .search-cmp,
    .hot-statistics {
      padding: 0 10px;
    }
  }

  .right-content {
    display: none;
  }

}
</style>
